import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';

interface PlanFeaturesProps {
  mainFeatures?: string[];
  features: string[];
}

export default function PlanFeatures({ mainFeatures = [], features }: PlanFeaturesProps) {
  return (
    <div className="space-y-8">
      {mainFeatures.length > 0 && (
        <ul className="space-y-3">
          {mainFeatures.map((feature, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center bg-primary/5 rounded-lg p-3"
            >
              <Check className="w-5 h-5 text-primary mr-3 flex-shrink-0" />
              <span className="text-gray-900 font-medium">{feature}</span>
            </motion.li>
          ))}
        </ul>
      )}
      
      <ul className="space-y-4">
        {features.map((feature, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: (mainFeatures.length + index) * 0.1 }}
            className="flex items-center min-h-[48px]"
          >
            <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
            <span className="text-gray-600 flex-1">{feature}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}